<link rel="stylesheet" media="all" [href]="printCssHref">
<main class="page-main">
  <div class="container layout layout--docs">
    <div class="layout__row">
      <div class="layout__sidecol d-none d-lg-block">
        <div class="details-nav">
          <nav class="details-nav__inner">
            <ul class="list-unstyled" id="docs-nav">
              <li class="is-active">
                <a href="everything.docs-broker-appointment-letter.html">Broker Appointment Letter</a>
              </li>
              <li>
                <a href="everything.docs-debit-order-authority.html">Debit Order Authority</a>
              </li>
              <li>
                <a href="everything.docs-terms-and-conditions.html">Terms and Conditions</a>
              </li>
              <li>
                <a href="everything.docs-fee-agreement.html">Fee Agreement</a>
              </li>
              <li>
                <a href="everything.policy-wording.html">Policy Wording</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <div class="layout__bodycol" id="search-body">
        <header class="docs-header docs-header--no-bdr">
          <div class="docs-header__company">
            <div class="docs-header__company-thumb">
              <img src="assets/insurer/santam.svg" class="img-fluid" />
            </div>
            <div class="docs-header__company-rating">
              <div class="stars-compact">
                <div class="stars-compact__star">
                  <svg class="icon"><use xlink:href="#star"></use></svg>
                </div>
                <div class="stars-compact__num">5</div>
              </div>
            </div>
            <div class="docs-header__company-name">
              <h6>Cost Conscious</h6>
            </div>
          </div>

          <div class="docs-header__title docs-header__title--col">
            <h1 class="font-serif">Tax Invoice</h1>
          </div>

          <div class="docs-header__grid">
            <div class="docs-header__grid-col docs-header__grid-col--left">
              <div class="docs-header__grid-cell">
                <p>
                  <strong>
                    Madikwe Futures Company NPC<br />
                    PO Box 775<br />
                    Groenkloof<br />
                    0027
                  </strong>
                </p>
              </div>
            </div>
            <div class="docs-header__grid-col docs-header__grid-col--right">
              <div class="docs-header__grid-cell">
                <ul class="data data--summary">
                  <li class="data__row">
                    <label class="data__label"> Invoice Number </label>
                    <div class="data__cell">
                      <strong>1267247</strong>
                    </div>
                  </li>
                  <li class="data__row">
                    <label class="data__label"> Invoice Date </label>
                    <div class="data__cell">
                      <strong>25/05/2021</strong>
                    </div>
                  </li>
                  <li class="data__row">
                    <label class="data__label"> Client No. </label>
                    <div class="data__cell">
                      <strong>-</strong>
                    </div>
                  </li>
                  <li class="data__row">
                    <label class="data__label"> VAT Reg. No. </label>
                    <div class="data__cell">
                      <strong>-</strong>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <div class="docs-header__grid-col docs-header__grid-col--left">
              <div class="docs-header__grid-cell">
                <ul class="data data--summary">
                  <li class="data__row">
                    <label class="data__label"> Insurer Name </label>
                    <div class="data__cell">Santam</div>
                  </li>
                  <li class="data__row">
                    <label class="data__label"> Category </label>
                    <div class="data__cell">Personal Insure</div>
                  </li>
                  <li class="data__row">
                    <label class="data__label"> Product </label>
                    <div class="data__cell">Cost Conscious</div>
                  </li>
                  <li class="data__row">
                    <label class="data__label"> Class </label>
                    <div class="data__cell">Vehicles, Buildings, Personal Items</div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="docs-header__grid-col docs-header__grid-col--right">
              <div class="docs-header__grid-cell">
                <ul class="data data--summary">
                  <li class="data__row">
                    <label class="data__label"> Policy No. </label>
                    <div class="data__cell">B1262BW0186220</div>
                  </li>
                  <li class="data__row">
                    <label class="data__label"> Broker Policy No. </label>
                    <div class="data__cell">SATIB137295</div>
                  </li>
                  <li class="data__row">
                    <label class="data__label"> Insurer Policy No. </label>
                    <div class="data__cell">B1262BW0186220</div>
                  </li>
                  <li class="data__row">
                    <label class="data__label"> Endorsement Date </label>
                    <div class="data__cell">01/06/2021</div>
                  </li>
                  <li class="data__row">
                    <label class="data__label"> Renewal Date </label>
                    <div class="data__cell">01/08/2021</div>
                  </li>
                </ul>
              </div>
            </div>

            <div class="docs-header__grid-col docs-header__grid-col--right">
              <div class="docs-header__grid-cell docs-header__grid-cell--total">
                <p>
                  <strong>
                    R 7 967.02
                    <small>due Jun 01, 2021</small>
                  </strong>
                </p>
              </div>
            </div>
          </div>
        </header>

        <section class="docs-content docs-content--wording docs-content--first" id="docs-overview">
          <div class="table-responsive">
            <table class="table table--financial">
              <thead>
              <tr>
                <th>Description</th>
                <th class="cell-fig">Amount (Excl. VAT)</th>
                <th class="cell-fig">VAT</th>
                <th class="cell-fig cell-total">Amount (Incl. VAT)</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>Vehicles</td>
                <td class="cell-fig">R 6 844.88</td>
                <td class="cell-fig">R 1 026.74</td>
                <td class="cell-fig cell-total">R 7 871.62</td>
              </tr>
              <tr>
                <td>SASRIA</td>
                <td class="cell-fig">R 39.50</td>
                <td class="cell-fig">R 5.90</td>
                <td class="cell-fig cell-total">R 45.40</td>
              </tr>
              <tr>
                <th colspan="4">Benefits</th>
              </tr>
              <tr class="row-sub">
                <td class="cell-indent">SATIB24</td>
                <td class="cell-fig">R 43.48</td>
                <td class="cell-fig">R 6.52</td>
                <td class="cell-fig cell-total">R 50.00</td>
              </tr>
              <tr class="row-sub">
                <td class="cell-indent">SATIB24</td>
                <td class="cell-fig">R 43.48</td>
                <td class="cell-fig">R 6.52</td>
                <td class="cell-fig cell-total">R 50.00</td>
              </tr>
              <tr class="row-sub">
                <td class="cell-indent">SATIB24</td>
                <td class="cell-fig">R 43.48</td>
                <td class="cell-fig">R 6.52</td>
                <td class="cell-fig cell-total">R 50.00</td>
              </tr>
              <tr class="row-sub">
                <td class="cell-indent">SATIB24</td>
                <td class="cell-fig">R 43.48</td>
                <td class="cell-fig">R 6.52</td>
                <td class="cell-fig cell-total">R 50.00</td>
              </tr>
              <tr>
                <td>Lorem Ipsum</td>
                <td class="cell-fig">R 6 844.88</td>
                <td class="cell-fig">R 1 026.74</td>
                <td class="cell-fig cell-total">R 7 871.62</td>
              </tr>
              <tr>
                <td>Dolor Sit Amet</td>
                <td class="cell-fig">R 39.50</td>
                <td class="cell-fig">R 5.90</td>
                <td class="cell-fig cell-total">R 5.90</td>
              </tr>
              <tr>
                <td>Lorem Ipsum</td>
                <td class="cell-fig">R 6 844.88</td>
                <td class="cell-fig">R 1 026.74</td>
                <td class="cell-fig cell-total">R 7 871.62</td>
              </tr>
              <tr>
                <td>Dolor Sit Amet</td>
                <td class="cell-fig">R 39.50</td>
                <td class="cell-fig">R 5.90</td>
                <td class="cell-fig cell-total">R 5.90</td>
              </tr>
              <tr>
                <td>Lorem Ipsum</td>
                <td class="cell-fig">R 6 844.88</td>
                <td class="cell-fig">R 1 026.74</td>
                <td class="cell-fig cell-total">R 7 871.62</td>
              </tr>
              <tr>
                <td>Dolor Sit Amet</td>
                <td class="cell-fig">R 39.50</td>
                <td class="cell-fig">R 5.90</td>
                <td class="cell-fig cell-total">R 5.90</td>
              </tr>
              <tr>
                <td>Lorem Ipsum</td>
                <td class="cell-fig">R 6 844.88</td>
                <td class="cell-fig">R 1 026.74</td>
                <td class="cell-fig cell-total">R 7 871.62</td>
              </tr>
              <tr>
                <td>Dolor Sit Amet</td>
                <td class="cell-fig">R 39.50</td>
                <td class="cell-fig">R 5.90</td>
                <td class="cell-fig cell-total">R 5.90</td>
              </tr>
              <tr class="row-total">
                <td><strong>Amount Due</strong></td>
                <td class="cell-fig">R 6 927.86</td>
                <td class="cell-fig">R 1 039.16</td>
                <td class="cell-fig"><strong>R 0.0</strong></td>
              </tr>
              <tr class="row-footnote">
                <td colspan="4">Total Commission Included in Premium shown above: R 350.55</td>
              </tr>
              </tbody>
            </table>
          </div>

          <div class="docs-content__details row row--xs mt-50">
            <div class="col">
              <div class="docs-content__details-cell">
                <h6>Banking Details</h6>
                <ul class="data data--summary">
                  <li class="data__row">
                    <label class="data__label"> Beneficiary </label>
                    <div class="data__cell">First Equity</div>
                  </li>
                  <li class="data__row">
                    <label class="data__label"> Bank </label>
                    <div class="data__cell">Rand Merchant Bank</div>
                  </li>
                  <li class="data__row">
                    <label class="data__label"> Account No. </label>
                    <div class="data__cell">62851356090</div>
                  </li>
                  <li class="data__row">
                    <label class="data__label"> Branch Code </label>
                    <div class="data__cell">255005</div>
                  </li>
                  <li class="data__row">
                    <label class="data__label"> Deposit Ref </label>
                    <div class="data__cell">SATIB 1 267 247</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="docs-content__details row row--xs mt-15">
            <div class="col">
              <div class="docs-content__details-cell">
                <h6>Broker Details</h6>
                <ul class="data data--summary">
                  <li class="data__row">
                    <label class="data__label"> Name </label>
                    <div class="data__cell">First Equity Insurance Brokers (Pty) Ltd</div>
                  </li>
                  <li class="data__row">
                    <label class="data__label"> Address </label>
                    <div class="data__cell">First Floor, Block A Hobert Square Office Park, Bryanston, 2191</div>
                  </li>
                  <li class="data__row">
                    <label class="data__label"> Reg No. </label>
                    <div class="data__cell">1996/017839/07</div>
                  </li>
                  <li class="data__row">
                    <label class="data__label"> Vat Reg. No. </label>
                    <div class="data__cell">4730152081</div>
                  </li>
                  <li class="data__row">
                    <label class="data__label"> FSP No. </label>
                    <div class="data__cell">5227</div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col">
              <div class="docs-content__details-cell">
                <h6>Insurer Details</h6>
                <ul class="data data--summary">
                  <li class="data__row">
                    <label class="data__label"> Name </label>
                    <div class="data__cell">Santam</div>
                  </li>
                  <li class="data__row">
                    <label class="data__label"> Address </label>
                    <div class="data__cell">Santam South Africa (Pty) Ltd 15th Floor, The Forum 2 Maude Street, Sandton 2146</div>
                  </li>
                  <li class="data__row">
                    <label class="data__label"> FSP Number </label>
                    <div class="data__cell">-</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</main>

<div class="policy-tray">
  <div class="policy-tray__details">
    <div class="container">
      <a href="#mobile-details" data-toggle="modal" class="button-control">
        <svg class="icon"><use xlink:href="#submenu-alt"></use></svg>
        <strong>More documents</strong>
      </a>
    </div>
  </div>
</div>

<footer class="docs-footer">
  <div class="docs-footer__inner container">
    <img id="logo" src="assets/0/logo.svg" alt="Everything.Insure" />
    <p>
      <strong>Questions?</strong> Contact Everything.Insure at<br />
      &lt;<a href="mailto:support@everything.insure">support&#64;everything.insure</a>&gt; or call <strong>011 510 1300</strong>
    </p>
  </div>
</footer>

<div class="modal fade fade-up modal--fullscreen" id="mobile-details" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <header class="modal-header">
        <div class="container">
          <h6>More documents</h6>
          <a href="#" class="modal-header__close" data-dismiss="modal">
            <svg class="icon"><use xlink:href="#close-medium"></use></svg>
          </a>
        </div>
      </header>

      <div class="modal-body">
        <div class="container">
          <div class="details-nav">
            <nav class="details-nav__inner">
              <ul class="list-unstyled" id="docs-nav-mobile">
                <li class="is-active">
                  <a href="everything.docs-broker-appointment-letter.html">Broker Appointment Letter</a>
                </li>
                <li>
                  <a href="everything.docs-debit-order-authority.html">Debit Order Authority</a>
                </li>
                <li>
                  <a href="everything.docs-terms-and-conditions.html">Terms and Conditions</a>
                </li>
                <li>
                  <a href="everything.docs-fee-agreement.html">Fee Agreement</a>
                </li>
                <li>
                  <a href="everything.policy-wording.html">Policy Wording</a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
